module.exports = __webpack_public_path__ + "media/packs/images/flags/TN-687080def7a337a37848e4f9c87ff554.png";